<div class="container-fluid">
  <form class="form-container" [formGroup]="form">
    <div class="first-row">
      <div class="box">
        <div class="filter-header">
          <h5>Date Range Filter</h5>
        </div>
        <div class="responsive-flex">
          <div class="col-auto">
            <mat-form-field appearance="outline">
              <mat-label>Range From</mat-label>
              <input matInput [matDatepicker]="dateFromPicker" formControlName="dateFrom" readonly />
              <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>

              <!-- Clear button for Range From -->
              <button mat-icon-button *ngIf="form.get('dateFrom')?.value" matSuffix (click)="clearDate('dateFrom')"
                aria-label="Clear Range From">
                <mat-icon class="text-gray-500 hover:text-red-600 cursor-pointer">close</mat-icon>
              </button>

              <mat-datepicker #dateFromPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-auto">
            <mat-form-field appearance="outline">
              <mat-label>Range To</mat-label>
              <input matInput [matDatepicker]="dateToPicker" formControlName="dateTo" readonly />

              <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
              <!-- Clear button for Range To -->
              <button mat-icon-button *ngIf="form.get('dateTo')?.value" matSuffix (click)="clearDate('dateTo')"
                aria-label="Clear Range To">
                <mat-icon class="text-gray-500 hover:text-red-600 cursor-pointer">close</mat-icon>
              </button>

              <mat-datepicker #dateToPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="button-group">
            <button mat-raised-button class="btn-bg" (click)="setDateRange('3d')">Last 3 Days</button>
            <button mat-raised-button class="btn-bg" (click)="setDateRange('1w')">Last 1 Week</button>
            <button mat-raised-button class="btn-bg" (click)="setDateRange('2w')">Last 2 Weeks</button>
            <button mat-raised-button class="btn-bg" (click)="setDateRange('1m')">Last 1 Month</button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Main content with equal height containers -->
  <div class="second-row">
    <div class="equal-height-container">

      <!-- Left Column: Chart Container -->
      <div class="chart-column">
        @if (selectedCategory != '') {
        <div class="breadcrumb-nav" style="margin-left: 5px;">
          <span>Category - {{ selectedCategory }}</span>
          <a class="back-link" (click)="resetCategory()"><- Back</a>
        </div>
        }
        <div class="chart-wrapper">
          <div id="container" class="highcharts-light"></div>
        </div>
      </div>

      <!-- Right Column: CSR Table -->
      <div class="table-column">
        @if (selectedUserName != '') {
        <div class="breadcrumb-nav" style="margin-left: 17.5px;">
          <span>Respondent - {{ selectedUserName }}</span>
          <a class="back-link" (click)="resetUserSelection()"><- Back</a>
        </div>
        }
        <mat-card class="dashboard-card">
          <mat-card-header>
            <mat-card-title>
              {{ "Users Table" | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="dashboard-card-content">
            <div class="csr-table-scroll-container">
              <table mat-table [dataSource]="csrDataSource" matSort #csrSort
                class="mat-elevation-z8 csr-table fixed-header-table">
                <!-- CSR Column -->
                <ng-container matColumnDef="csr">
                  <th mat-header-cell *matHeaderCellDef class="details-row sortable-header" (click)="sortCSR('csr')">
                    Respondent
                    <mat-icon *ngIf="csrSortState.column === 'csr' && csrSortState.direction === 'asc'"
                      class="sort-icon">arrow_upward</mat-icon>
                    <mat-icon *ngIf="csrSortState.column === 'csr' && csrSortState.direction === 'desc'"
                      class="sort-icon">arrow_downward</mat-icon>
                  </th>
                  <td mat-cell *matCellDef="let row" class="csr-rows"
                    [style.pointer-events]="userRole === 'DASHBOARD' ? 'none' : 'auto'"
                    [style.cursor]="userRole === 'DASHBOARD' ? 'default' : 'pointer'"
                    (click)="userRole !== 'DASHBOARD' && onRowClick(row[0])">
                    {{ row[0] }}
                  </td>
                </ng-container>
                <!-- Total Complaints Column -->
                <ng-container matColumnDef="totalComplaints">
                  <th mat-header-cell *matHeaderCellDef class="details-row sortable-header"
                    (click)="sortCSR('totalComplaints')">
                    Total Complaints
                    <mat-icon *ngIf="csrSortState.column === 'totalComplaints' && csrSortState.direction === 'asc'"
                      class="sort-icon">arrow_upward</mat-icon>
                    <mat-icon *ngIf="csrSortState.column === 'totalComplaints' && csrSortState.direction === 'desc'"
                      class="sort-icon">arrow_downward</mat-icon>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row[1] }}
                  </td>
                </ng-container>
                <!-- Average Response Time Column -->
                <ng-container matColumnDef="avgResponseTime">
                  <th mat-header-cell *matHeaderCellDef class="details-row sortable-header"
                    (click)="sortCSR('avgResponseTime')">
                    Avg Response Time
                    <mat-icon *ngIf="csrSortState.column === 'avgResponseTime' && csrSortState.direction === 'asc'"
                      class="sort-icon">arrow_upward</mat-icon>
                    <mat-icon *ngIf="csrSortState.column === 'avgResponseTime' && csrSortState.direction === 'desc'"
                      class="sort-icon">arrow_downward</mat-icon>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row[2] }} Days
                  </td>
                </ng-container>
                <!-- Header and Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="csrDisplayedColumns; sticky: true" style="text-align: center;"></tr>
                <tr mat-row *matRowDef="let row; columns: csrDisplayedColumns;" class="clickable-row"></tr>
                <!-- No Data Row -->
                <tr class="mat-row no-data-row" *matNoDataRow>
                  <td class="mat-cell" colspan="3">
                    {{ "NO DATA FOUND" | translate }}
                  </td>
                </tr>
              </table>
            </div>
          </mat-card-content>
          <!-- Paginator -->
          <div class="paginator-container">
            <mat-paginator #csrPaginator class="custom-paginator" [pageSizeOptions]="csrConfig.pageSizeOptionsList"
              [pageSize]="5" showFirstLastButtons>
            </mat-paginator>
          </div>

        </mat-card>
      </div>
    </div>
  </div>

  <!-- Details Table -->
  <div class="details-table-section">
    <div class="table-wrapper">
      <div class="table-scroll-container">
        <table mat-table [dataSource]="detailsDataSource" class="mat-elevation-z8 fixed-header-table">
          <ng-container matColumnDef="csr">
            <th mat-header-cell *matHeaderCellDef class="details-head" (click)="sortDetailsByRespondent()">
              <span class="header-label">
                Respondent
                <ng-container [ngSwitch]="sortStateDetailsByRespondent">
                  <mat-icon *ngSwitchCase="1" class="sort-icon">arrow_upward</mat-icon>
                  <mat-icon *ngSwitchCase="2" class="sort-icon">arrow_downward</mat-icon>
                </ng-container>
              </span>
            </th>
            <td mat-cell *matCellDef="let row" class="details-row">{{ row[0] }}</td>
          </ng-container>


          <ng-container matColumnDef="complaintNo">
            <th mat-header-cell *matHeaderCellDef class="details-row">Complaint No.</th>
            <td mat-cell *matCellDef="let row" class="details-row">{{ row[1] }}</td>
          </ng-container>

          <ng-container matColumnDef="receivedDate">
            <th mat-header-cell *matHeaderCellDef class="details-row">Lodge Date</th>
            <td mat-cell *matCellDef="let row" class="details-row">{{ row[3] }}</td>
          </ng-container>

          <ng-container matColumnDef="closedDate">
            <th mat-header-cell *matHeaderCellDef class="details-row">First Response Date</th>
            <td mat-cell *matCellDef="let row" class="details-row">{{ row[4] }}</td>
          </ng-container>

          <ng-container matColumnDef="avgResponseTime">
            <th mat-header-cell *matHeaderCellDef class="details-row">Duration</th>
            <td mat-cell *matCellDef="let row" class="details-row">{{ row[5] }}</td>
          </ng-container>

          <ng-container matColumnDef="complainantType">
            <th mat-header-cell *matHeaderCellDef class="details-head" (click)="sortDetailsByComplainantType()">
              <span class="header-label">
                Complainant Type
                <ng-container [ngSwitch]="sortStateDetailsByType">
                  <mat-icon *ngSwitchCase="1" class="sort-icon">
                    arrow_upward
                  </mat-icon>
                  <mat-icon *ngSwitchCase="2" class="sort-icon">
                    arrow_downward
                  </mat-icon>
                </ng-container>
              </span>
            </th>
            <td mat-cell *matCellDef="let row" class="details-row">
              {{ row[6] }}
            </td>
          </ng-container>

          <ng-container matColumnDef="complaintType">
            <th mat-header-cell *matHeaderCellDef class="details-head" (click)="sortDetailsByComplaintType()">
              <span class="header-label">
                Complaint Type
                <ng-container [ngSwitch]="sortStateDetailsByComplaintType">
                  <mat-icon *ngSwitchCase="1" class="sort-icon">
                    arrow_upward
                  </mat-icon>
                  <mat-icon *ngSwitchCase="2" class="sort-icon">
                    arrow_downward
                  </mat-icon>
                </ng-container>
              </span>
            </th>
            <td mat-cell *matCellDef="let row" class="details-row">
              {{ row[7] }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="details-row">Action</th>

            <td mat-cell *matCellDef="let row" class="details-row">
              <button mat-icon-button color="secondary" (click)="viewComplaint(row)"
                [disabled]="userRole === 'DASHBOARD'">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="detailsDisplayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: detailsDisplayedColumns;"></tr>
        </table>
      </div>

      <mat-paginator #detailsPaginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

</div>